export enum LinkTypeEnum {
  email = 'email',
  intern = 'intern',
  extern = 'extern',
}
